var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

export { __name };
//# sourceMappingURL=chunk-7QVYU63E.js.map
//# sourceMappingURL=chunk-7QVYU63E.js.map